/**
 * OIDC Authentication Provider for Report Summarizer
 * Wraps the oidc-react library with HappyCo-specific configuration
 */

import { ReactNode } from 'react'
import { AuthProvider } from 'oidc-react'
import { createOIDCConfig } from './config'

interface OIDCAuthProviderProps {
  children: ReactNode
}

/**
 * OIDC provider wrapper that configures authentication for Report Summarizer
 */
export function OIDCAuthProvider({ children }: OIDCAuthProviderProps) {
  const oidcConfig = createOIDCConfig()

  return (
    <AuthProvider
      authority={oidcConfig.authority}
      clientId={oidcConfig.clientId}
      scope={oidcConfig.scope}
      redirectUri={oidcConfig.redirectUri}
      postLogoutRedirectUri={oidcConfig.postLogoutRedirectUri}
      automaticSilentRenew={oidcConfig.automaticSilentRenew}
      loadUserInfo={oidcConfig.loadUserInfo}
      extraQueryParams={{ tenantId: oidcConfig.tenantId }}
    >
      {children}
    </AuthProvider>
  )
}